import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { switchMap, map } from 'rxjs/operators';
import { CombinedVaccineData, CombinedVaccine } from '../../../interfaces/masters/combined-vaccine';
import { CombinedVaccineApi } from '../api/combined-vaccine.api';

@Injectable() 
export class CombinedVaccineService extends CombinedVaccineData{
 
  constructor(private api: CombinedVaccineApi) {
    super();
  } 
  
  getall(url: string): Observable<CombinedVaccine[]> {  
    return this.api.getall(url);
  } 

  getById(url:string): Observable<CombinedVaccine>{
      return this.api.getby_id(url);
  }

  create(url: string, data:CombinedVaccine): Observable<CombinedVaccine[]> {
    return this.api.add(url,data);
  }

  update(url: string, data:CombinedVaccine): Observable<CombinedVaccine> { 
    return this.api.update(url,data);
  }  

  list(url: string): Observable<any> {
    return this.api.list(url);
  }

  searchList(url: string,data:any): Observable<any> {  
    return this.api.searchList(url,data);
  }

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
